import { useNavigate, useLocation } from 'react-router-dom'
import { LucideIcon } from 'lucide-react'

interface Tab {
  id: string
  label: string
  icon: LucideIcon
  path: string
}

interface BottomNavProps {
  tabs: Tab[]
}

export default function BottomNav({ tabs }: BottomNavProps) {
  const navigate = useNavigate()
  const location = useLocation()

  const handleTabClick = (tab: Tab) => {
    navigate(tab.path)
  }

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-surface-600 safe-area-bottom">
      <div className="flex items-center justify-around px-2 py-2">
        {tabs.map((tab) => {
          const Icon = tab.icon
          const isActive = location.pathname === tab.path

          return (
            <button
              key={tab.id}
              onClick={() => handleTabClick(tab)}
              className={`flex flex-col items-center justify-center px-3 py-2 rounded-lg transition-colors touch-target ${
                isActive
                  ? 'text-brand-600 bg-brand-100'
                  : 'text-text-700 hover:text-brand-600 hover:bg-brand-50'
              }`}
            >
              <Icon
                size={20}
                className={`mb-1 ${isActive ? 'stroke-2' : 'stroke-1.5'}`}
              />
              <span className="text-xs font-medium leading-none">
                {tab.label}
              </span>
            </button>
          )
        })}
      </div>
    </nav>
  )
}
